/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

const trackingUtils = require('../../modules/utils/tracking.utils');

const PRICE_TYPE = {
    SUBSCRIPTION_PRICE: 'fee',
    DISCOUNT: 'discount',
};

module.exports = Odigeo.Model.extend({
    hasBeenEvaluated: false,
    subscriptionFee: null,
    discount: null,
    init: function() {
        this.options = Odigeo.Utils.parseOptions(this.widget.options);
        this.set({
            'subscriptionFee': +this.options.membershipSubscriptionPrice,
            'discount': +this.options.membershipDiscount,
        });
    },
    trackPriceZero: function(loggedIn, isPrimeUser) {
        const subscriptionFee = this.get('subscriptionFee');
        const discount = this.get('discount');
        const scenario = loggedIn ? (isPrimeUser ? 'login-prime' : 'login') : 'no-login';
        if (discount === 0) {
            trackingUtils.trackEvent('back_end_errors', `prime_widget_price_${PRICE_TYPE.DISCOUNT}_error_sce:${scenario}`);
        }
        if (subscriptionFee === 0) {
            trackingUtils.trackEvent('back_end_errors', `prime_widget_price_${PRICE_TYPE.SUBSCRIPTION_PRICE}_error_sce:${scenario}`);
        }
        this.set('hasBeenEvaluated', true);
    },

    trackPriceDiscount: function() {
        if (this.options.isPrimeWithMeta) {
            const totalPrice = this.options.totalPrice ? (+this.options.totalPrice).toFixed(2, 10) : 0;
            const discount = this.get('discount');
            const absDiffPrice = Math.abs(discount).toFixed(2, 10);
            const relDiffPrice = totalPrice > 0 ? ((discount/totalPrice)*100).toFixed(2, 10) : 0;
            const label = `metapr:${totalPrice}_primepr:${(+this.options.totalPrice +
                this.get('discount')).toFixed(2, 10)}_difabs:${absDiffPrice}_difrel:${relDiffPrice}`;
            trackingUtils.trackEventWithCategory(Odigeo.SessionScope.flow === 'desktop' ?
                'flights_pax_page' : 'flights_summary', 'prime_price', label);
        }
    },
});
